import { apiClient } from './api';
import type { InvitationValidateResponse } from '@/types/invitation';

/**
 * 招待トークンを検証する
 * @param token 招待トークン
 * @returns 招待情報
 */
export const validateInvitation = async (
  token: string
): Promise<InvitationValidateResponse> => {
  const response = await apiClient.get<InvitationValidateResponse>(
    `/v1/invitation/validate/${token}`
  );
  return response.data;
};
